import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppService } from '../../app.service';
import { BillingClient } from '../../pages/monthly-billing-config/interfaces/billing-client.interface';
import { BillingTermDetail } from '../../pages/monthly-billing-config/interfaces/billing-term-detail.interface';

@Injectable({
    providedIn: 'root',
})
export class MonthlyBillingConfigService {
    private _baseUrl: string = '';
    private _token: string = '';

    public constructor(
        public appService: AppService,
        public http: HttpClient,
        @Inject('API_BASE_URL') baseurl: string
    ) {
        this._baseUrl = baseurl;

        const loggedUserSession = localStorage.getItem('userSession');
        if (loggedUserSession) {
            const loggedUserToken =
                JSON.parse(loggedUserSession).AuthenticatedUser.Token;
            this._token = loggedUserToken;
        }
    }

    public httpGetAllBillingClients = (
        page: number = 1,
        rows: number = 10
    ): Observable<any> => {
        const apipath: string =
            'MonthlyBillingConfig/clients' + '?page=' + page + '&rows=' + rows;
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public httpGetAllCities = (): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/cities';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public httpGetAllStates = (): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/states';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public httpPostBillingClient = (client: BillingClient): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/client';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();
        const params: any = { ...client };

        return this.http.post<any>(fullPath, params, options);
    };

    public httpPutBillingClient = (client: BillingClient): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/client';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();
        const params: any = { ...client };

        return this.http.put<any>(fullPath, params, options);
    };

    public httpDeleteBillingClient = (id: number): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/client/' + id;
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.delete<any>(fullPath, options);
    };

    public httpGetBillingTermDetail = (
        id: number,
        page: number = 1,
        rows: number = 10
    ): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/term-details/' + id;
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public httpGetAllTermType = (): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/term-types';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.get<any>(fullPath, options);
    };

    public httpPostBillingTermDetail = (
        termDetail: BillingTermDetail
    ): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/term-detail';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();
        const params: any = { ...termDetail };

        return this.http.post<any>(fullPath, params, options);
    };

    public httpPutBillingTermDetail = (
        termDetail: BillingTermDetail
    ): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/term-detail';
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();
        const params: any = { ...termDetail };

        return this.http.put<any>(fullPath, params, options);
    };

    public httpDeleteBillingTermDetail = (id: number): Observable<any> => {
        const apipath: string = 'MonthlyBillingConfig/term-detail/' + id;
        const fullPath: string = this._baseUrl + apipath;
        const options = this.appService.getHttpHeaderOptions();

        return this.http.delete<any>(fullPath, options);
    };
}
